enum PageRoutes {
    Login = "/login",
    ResetPassword = "/reset-password",
    Dashboard = "/dashboard",
    ThirdPartyAccounts = "/accounts/third-party-accounts",
    ThirdPartyAccount = "/accounts/third-party-accounts/:id",
    InstitutionAccounts = "/accounts/institutional-accounts",
    InstitutionAccount = "/accounts/institutional-accounts/:id",
    DepositAccounts = "/accounts/deposit-accounts",
    DepositAccount = "/accounts/deposit-accounts/:id",
    LendingAccounts = "/accounts/lending-accounts",
    LendingAccount = "/accounts/lending-accounts/:id",
    Customers = "/customers/customers",
    Customer = "/customers/customers/:id",
    People = "/customers/people",
    Person = "/customers/people/:id",
    Organisations = "/customers/organisations",
    Organisation = "/customers/organisations/:id",
    Products = "/products/products",
    Product = "/products/products/:id",
    ProductWizard = "/products/create-product",
    ProductWizardSelector = "/products/product-selector",
    ProductIssues = "/products/product-issues",
    ProductIssue = "/products/product-issues/:id",
    ProductMigrations = "/products/product-migrations",
    ProductMigration = "/products/product-migrations/:id",
    RateSources = "/products/rate-sources",
    RateSource = "/products/rate-sources/:id",
    SubTransactionTypes = "/products/sub-transaction-types",
    SubTransactionType = "/products/sub-transaction-types/:id",
    GeneralLedgerAccounts = "/accounting/general-ledger-accounts",
    GeneralLedgerAccount = "/accounting/general-ledger-accounts/:id",
    JournalEntries = "/accounting/journal-entries",
    JournalEntry = "/accounting/journal-entries/:id",
    Reports = "/reporting/reports",
    Users = "/settings/users",
    User = "/settings/user/:id",
    Roles = "/settings/roles",
    Role = "/settings/roles/:id",
    AppMediums = "/settings/app-mediums",
    AppMedium = "/settings/app-mediums/:id",
    Webhooks = "/settings/webhooks",
    Webhook = "/settings/webhooks/:id",
    Institutions = "/settings/institutions",
    Institution = "/settings/institutions/:id",
    Regions = "/settings/regions",
    Region = "/settings/regions/:id",
    CoreApiDocumentation = "/documentation/core-api",
    FiDocumentation = "/documentation/fi-documentation",
    FiCustomDocumentation = "/documentation/fi-custom-documentation",
    UxDocumentation = "/documentation/ux-documentation",
    UxCustomDocumentation = "/documentation/ux-custom-documentation",
    Sso = "/6a4c27e2-728d-4e06-a981-71ef3db02baf"
}
export default PageRoutes;